var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictures(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    height: "2.22rem",
    width: "2.22rem",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pictures"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49,10H9a1,1,0,0,0-1,1V47a1,1,0,0,0,1,1H49a1,1,0,0,0,1-1V11A1,1,0,0,0,49,10ZM48,46H10V12H48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,3a1,1,0,0,0-1-1H1A1,1,0,0,0,0,3V39a1,1,0,0,0,2,0V4H41A1,1,0,0,0,42,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.57,39h28.1c.31,0,.42-.21.25-.46L33.52,23.8a.37.37,0,0,0-.64,0l-5.62,8a.38.38,0,0,1-.65,0L23.68,27.6a.38.38,0,0,0-.65,0L15.32,38.54C15.14,38.79,15.26,39,15.57,39Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 22.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,7a1,1,0,0,0-1-1H5A1,1,0,0,0,4,7V43a1,1,0,0,0,2,0V8H45A1,1,0,0,0,46,7Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictures);
export default __webpack_public_path__ + "static/media/Pictures.7749f166.svg";
export { ForwardRef as ReactComponent };